import { render, staticRenderFns } from "./MenuOptionFilters.vue?vue&type=template&id=72926062"
import script from "./MenuOptionFilters.vue?vue&type=script&lang=js"
export * from "./MenuOptionFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports